var map = {
	"./amex.svg": "9dda",
	"./bandeira-visa.svg": "193c",
	"./diners.svg": "12da",
	"./generic.svg": "a1d2",
	"./google.svg": "7f6a",
	"./master.svg": "95f0",
	"./mastercard.svg": "b856",
	"./visa.svg": "43f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7769";